var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGroup3Fill = function SvgGroup3Fill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.583 7.833a3.333 3.333 0 1 0 6.667 0 3.333 3.333 0 0 0-6.667 0M4.167 19.5v-3.75a3.75 3.75 0 1 1 7.5 0v3.75zm12.916-8.333a3.333 3.333 0 1 1 0-6.667 3.333 3.333 0 0 1 0 6.667m-3.75 8.333v-3.75a3.75 3.75 0 1 1 7.5 0v3.75z"
  })));
};
export default SvgGroup3Fill;